import './App.css';
import './performance-optimizations.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminDashboardLayout from './components/AdminDashboardLayout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import SuperAdminDashboardPage from './pages/SuperAdminDashboardPage';
import SuperAdminLoginPage from './pages/SuperAdminLoginPage';


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin Portal Routes */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="admin/login" element={<AdminLoginPage />} />
        <Route path="super-admin/login" element={<SuperAdminLoginPage />} />

        {/* Main Admin Dashboard - Shared by all admin roles (permissions handled internally) */}
        <Route element={<ProtectedAdminRoute><AdminDashboardLayout /></ProtectedAdminRoute>}>
          <Route path="admin/super-dashboard" element={<SuperAdminDashboardPage />} />
          <Route path="admin/dashboard" element={<SuperAdminDashboardPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
